import {
  classToValidate,
  classToValidationFunction,
  Textarea,
} from '@apia/validations';
import React from 'react';
import { TApiaApiField } from '../ApiaApiHandler';

export const ApiaApiTextArea = (props: TApiaApiField) => {
  const element = React.useMemo(() => props.element, [props.element]);

  const className = React.useMemo(
    () =>
      element.class
        ? `handler__textarea ${element.class}`
        : 'handler__textarea',
    [element.class],
  );
  const validationRules = React.useMemo(
    () => ({
      required: element.mandatory,
      maxLength: element.maxlength ? Number(element.maxlength) : undefined,
      pattern: element.regExp,
      patternMessage: element.regExpMessage,
      ...classToValidate(element.class),
    }),
    [
      element.class,
      element.mandatory,
      element.maxlength,
      element.regExp,
      element.regExpMessage,
    ],
  );
  const validationFunction = React.useMemo(
    () => classToValidationFunction(element.class),
    [element.class],
  );

  return (
    <Textarea
      className={className}
      name={element.id || element.name}
      label={element.text}
      title={element.title || element.text}
      value={element.value}
      readOnly={element.readonly}
      disabled={element.disabled}
      validationFunction={validationFunction}
      validationRules={validationRules}
      onChange={element.onChange}
    />
  );
};

ApiaApiTextArea.displayName = 'ApiaApiTextArea';
